/* ETENWOLF Collection modules. No global product or collection data is changed. */
(() => {
  'use strict';
  if (window.EWCCollections) { window.EWCCollections.init(document); return; }
  const instances = new WeakMap();
  const roots = new Set();
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined && text !== null) element.textContent = String(text);
    return element;
  };
  const safeLink = (value) => {
    try { const url = new URL(value, window.location.origin); return ['http:', 'https:'].includes(url.protocol) ? url.href : '#'; }
    catch (_) { return '#'; }
  };

  class Catalog {
    constructor(root) {
      this.root = root;
      this.abort = new AbortController();
      this.listen = (target, type, callback, options = {}) => target?.addEventListener(type, callback, { ...options, signal: this.abort.signal });
      try { this.data = JSON.parse(root.querySelector('[data-ewc-data]').textContent); }
      catch (_) { return; }
      this.products = Array.isArray(this.data.products) ? this.data.products : [];
      this.products = this.products.filter((p, index, list) => p.id && list.findIndex((other) => other.id === p.id) === index);
      this.attributes = Array.isArray(this.data.attributes) ? this.data.attributes.filter((a) => a.label && /^([1-9]|1[0-5])$/.test(String(a.slot))) : [];
      this.byId = new Map(this.products.map((p) => [String(p.id), p]));
      this.cards = new Map([...root.querySelectorAll('[data-ewc-card]')].map((card) => [card.dataset.ewcCard, card]));
      this.small = window.matchMedia('(max-width: 700px)');
      this.mode = 'recommended';
      this.selected = this.defaults();
      this.expanded = false;
      this.filterGroup = '';
      this.sort = 'featured';
      this.scroll = root.querySelector('[data-ewc-scroll-area]');
      this.status = root.querySelector('[data-ewc-status]');
      this.buildFilters();
      this.listen(root, 'click', (event) => this.onClick(event));
      this.listen(root, 'change', (event) => this.onChange(event));
      this.listen(this.small, 'change', () => {
        if (this.mode === 'recommended') this.selected = this.defaults();
        else if (this.mode === 'selected') this.selected = this.selected.slice(0, this.limit());
        this.renderComparison();
      });
      this.listen(window, 'resize', () => this.updateArrows(), { passive: true });
      this.listen(this.scroll, 'scroll', () => this.updateArrows(), { passive: true });
      this.listen(root, 'shopify:block:select', (event) => this.selectEditorBlock(event.detail?.blockId));
      this.setupDrag();
      if (this.products.length) {
        const toolbar = root.querySelector('[data-ewc-toolbar]');
        if (toolbar) toolbar.hidden = false;
        if (this.attributes.length) root.querySelectorAll('[data-ewc-compare-control]').forEach((control) => { control.hidden = false; });
      }
      this.renderCards();
      this.renderComparison();
    }
    limit() { return this.small.matches ? 2 : 3; }
    defaults() {
      return [...this.products.filter((p) => p.recommended), ...this.products.filter((p) => !p.recommended)].slice(0, this.limit()).map((p) => String(p.id));
    }
    announce(message) { if (this.status) this.status.textContent = message; }
    buildFilters() {
      const wrapper = this.root.querySelector('[data-ewc-filters]');
      if (!wrapper) return;
      const groups = [...new Set(this.products.map((p) => String(p.group || '').trim()).filter(Boolean))];
      this.groups = groups;
      const all = make('button', 'is-active', 'All models');
      all.type = 'button'; all.dataset.ewcFilter = ''; all.setAttribute('aria-pressed', 'true');
      wrapper.appendChild(all);
      groups.forEach((group) => {
        const button = make('button', '', group);
        button.type = 'button'; button.dataset.ewcFilter = group; button.setAttribute('aria-pressed', 'false');
        wrapper.appendChild(button);
      });
      wrapper.hidden = groups.length < 2;
    }
    filter(group) {
      const candidate = String(group || '').trim();
      const exact = (this.groups || []).find((value) => value.toLowerCase() === candidate.toLowerCase());
      if (candidate && !exact) return false;
      this.filterGroup = exact || '';
      this.renderCards();
      document.querySelectorAll('.ewc-guide [data-ewc-filter]').forEach((button) => {
        const active = String(button.dataset.ewcFilter || '').trim().toLowerCase() === this.filterGroup.toLowerCase();
        button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active));
      });
      return true;
    }
    renderCards() {
      const grid = this.root.querySelector('[data-ewc-grid]');
      if (!grid) return;
      let products = [...this.products];
      if (this.sort !== 'featured') products.sort((a, b) => {
        const aHasPrice = typeof a.price === 'number';
        const bHasPrice = typeof b.price === 'number';
        if (!aHasPrice && !bHasPrice) return 0;
        if (!aHasPrice) return 1;
        if (!bHasPrice) return -1;
        return (a.price - b.price) * (this.sort === 'price-desc' ? -1 : 1);
      });
      let count = 0;
      products.forEach((product) => {
        const card = this.cards.get(String(product.id));
        if (!card) return;
        const shown = !this.filterGroup || String(product.group || '').trim() === this.filterGroup;
        card.hidden = !shown;
        if (shown) count += 1;
        grid.appendChild(card);
      });
      const visibleCards = [...grid.children].filter((card) => !card.hidden);
      [...grid.children].forEach((card) => {
        const visibleIndex = visibleCards.indexOf(card);
        card.classList.toggle('is-wide', count % 3 === 1 && visibleIndex === count - 1);
        card.classList.toggle('is-half', count % 3 === 2 && visibleIndex >= count - 2 && visibleIndex >= 0);
      });
      const countLabel = this.root.querySelector('[data-ewc-count]');
      if (countLabel) countLabel.textContent = `${count} ${count === 1 ? 'model' : 'models'}`;
      const empty = this.root.querySelector('[data-ewc-empty]');
      if (empty) empty.hidden = count > 0;
      this.root.querySelectorAll('[data-ewc-filter]').forEach((button) => {
        const active = button.dataset.ewcFilter === this.filterGroup;
        button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active));
      });
    }
    onClick(event) {
      const filter = event.target.closest('[data-ewc-filter]');
      if (filter) this.filter(filter.dataset.ewcFilter);
      const mode = event.target.closest('[data-ewc-mode]');
      if (mode) {
        this.mode = mode.dataset.ewcMode;
        if (this.mode === 'recommended') this.selected = this.defaults();
        this.renderComparison();
      }
      if (event.target.closest('[data-ewc-expand]')) {
        const previousTop = this.scroll?.scrollTop || 0;
        this.expanded = !this.expanded;
        this.renderComparison();
        if (this.scroll) this.scroll.scrollTop = this.expanded ? previousTop : 0;
        this.announce(this.expanded ? 'All specifications are shown.' : 'Key specifications are shown.');
      }
      const arrow = event.target.closest('[data-ewc-scroll]');
      if (arrow && this.scroll) this.scroll.scrollBy({ left: Number(arrow.dataset.ewcScroll) * Math.max(240, this.scroll.clientWidth * 0.65), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    onChange(event) {
      if (event.target.matches('[data-ewc-sort]')) { this.sort = event.target.value; this.renderCards(); }
      if (event.target.matches('[data-ewc-model-select]')) {
        const index = Number(event.target.dataset.ewcModelSelect);
        const incoming = event.target.value;
        if (!this.byId.has(incoming)) return;
        const old = this.selected[index];
        const existing = this.selected.indexOf(incoming);
        if (existing !== -1 && existing !== index) this.selected[existing] = old;
        this.selected[index] = incoming;
        this.mode = 'selected';
        this.renderComparison();
        this.root.querySelector(`[data-ewc-model-select="${index}"]`)?.focus({ preventScroll: true });
        this.announce(`${this.byId.get(incoming).title} selected for comparison.`);
      }
      if (event.target.matches('[data-ewc-choose]')) {
        const id = event.target.value;
        if (!this.byId.has(id)) return;
        if (this.mode === 'all') this.selected = this.defaults();
        this.mode = 'selected';
        if (event.target.checked && !this.selected.includes(id)) {
          if (this.selected.length >= this.limit()) this.selected.shift();
          this.selected.push(id);
        } else if (!event.target.checked) this.selected = this.selected.filter((selected) => selected !== id);
        if (!this.selected.length) { this.mode = 'recommended'; this.selected = this.defaults(); }
        this.renderComparison();
        this.announce(`${this.selected.length} ${this.selected.length === 1 ? 'model' : 'models'} selected. See the comparison below.`);
      }
    }
    productHeader(product, index, useSelector) {
      const cell = make('th', 'ewc-comparison__product');
      cell.scope = 'col';
      if (useSelector) {
        const label = make('label', 'ewc-sr-only', `Model in comparison column ${index + 1}`);
        const select = make('select', 'ewc-comparison__select');
        const id = `ewc-model-${this.root.dataset.sectionId}-${index}`;
        label.htmlFor = id; select.id = id; select.dataset.ewcModelSelect = String(index);
        this.products.forEach((p) => { const option = make('option', '', p.title); option.value = String(p.id); option.selected = String(p.id) === String(product.id); select.appendChild(option); });
        cell.append(label, select);
      } else cell.appendChild(make('p', 'ewc-comparison__model-label', product.title));
      const link = make('a', 'ewc-comparison__product-link');
      link.href = safeLink(product.url);
      if (product.external) { link.target = '_blank'; link.rel = 'noopener'; }
      if (product.image) { const image = make('img'); image.src = safeLink(product.image); image.alt = product.title || ''; image.width = 120; image.height = 120; image.loading = 'lazy'; link.appendChild(image); }
      link.appendChild(make('span', 'ewc-comparison__product-name', product.title));
      cell.appendChild(link);
      if (product.priceText) cell.appendChild(make('p', 'ewc-comparison__price', `${product.priceVaries ? 'From ' : ''}${product.priceText}`));
      if (product.priceNote) cell.appendChild(make('p', 'ewc-comparison__price-note', product.priceNote));
      return cell;
    }
    renderComparison() {
      if (!this.scroll) return;
      const ui = this.root.querySelector('[data-ewc-comparison-ui]');
      if (!this.products.length || !this.attributes.length) {
        if (ui) ui.hidden = true;
        const comparison = this.root.querySelector('[data-ewc-comparison]');
        if (comparison) comparison.hidden = !window.Shopify?.designMode;
        return;
      }
      if (ui) ui.hidden = false;
      this.selected = [...new Set(this.selected)].filter((id) => this.byId.has(id));
      if (!this.selected.length) this.selected = this.defaults();
      const columns = this.mode === 'all' ? this.products : this.selected.map((id) => this.byId.get(id));
      const summaries = this.attributes.filter((attribute) => attribute.summary);
      const rows = this.expanded || !summaries.length ? this.attributes : summaries;
      const left = this.scroll.scrollLeft;
      const top = this.scroll.scrollTop;
      const table = make('table', 'ewc-comparison__table');
      table.style.setProperty('--ewc-model-count', String(columns.length));
      const caption = make('caption', 'ewc-sr-only', `Specifications for ${columns.map((p) => p.title).join(', ')}`);
      const thead = make('thead');
      const header = make('tr');
      const label = make('th', 'ewc-comparison__feature', 'Compare models');
      label.scope = 'col'; header.appendChild(label);
      columns.forEach((p, index) => header.appendChild(this.productHeader(p, index, this.mode !== 'all')));
      thead.appendChild(header);
      const body = make('tbody');
      let lastGroup = null;
      rows.forEach((attribute) => {
        if (this.expanded && attribute.group && attribute.group !== lastGroup) {
          const groupRow = make('tr', 'ewc-comparison__group');
          const groupHeader = make('th', '', attribute.group); groupHeader.scope = 'row';
          groupRow.appendChild(groupHeader);
          columns.forEach(() => { const empty = make('td'); empty.setAttribute('aria-hidden', 'true'); groupRow.appendChild(empty); });
          body.appendChild(groupRow); lastGroup = attribute.group;
        }
        const row = make('tr'); row.dataset.ewcAttribute = String(attribute.id);
        const heading = make('th', 'ewc-comparison__feature', attribute.label); heading.scope = 'row'; row.appendChild(heading);
        columns.forEach((product) => {
          const value = product.specs?.[String(attribute.slot)];
          row.appendChild(make('td', '', value === undefined || value === null || String(value).trim() === '' ? '—' : value));
        });
        body.appendChild(row);
      });
      table.append(caption, thead, body);
      this.scroll.replaceChildren(table);
      this.scroll.classList.toggle('is-expanded', this.expanded);
      this.scroll.classList.toggle('is-all', this.mode === 'all');
      this.scroll.scrollLeft = left; this.scroll.scrollTop = top;
      const count = this.root.querySelector('[data-ewc-compare-count]');
      if (count) count.textContent = `${columns.length} ${columns.length === 1 ? 'model' : 'models'}`;
      const hint = this.root.querySelector('[data-ewc-hint]');
      if (hint) hint.textContent = this.mode === 'all' ? 'Scroll sideways or use the arrows to explore all models.' : 'Choose a model above each column to compare. Selecting an existing model swaps the two columns.';
      const expand = this.root.querySelector('[data-ewc-expand]');
      if (expand) {
        expand.hidden = !summaries.length || summaries.length === this.attributes.length;
        expand.setAttribute('aria-expanded', String(this.expanded));
        expand.textContent = this.expanded ? 'Show key specifications −' : `View all specifications (${this.attributes.length}) +`;
      }
      this.root.querySelectorAll('[data-ewc-mode]').forEach((button) => {
        const active = button.dataset.ewcMode === (this.mode === 'all' ? 'all' : 'recommended');
        button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active));
        if (button.dataset.ewcMode === 'recommended') button.textContent = this.mode === 'selected' ? 'Your selection · Reset' : 'Recommended models';
      });
      this.root.querySelectorAll('[data-ewc-choose]').forEach((input) => { input.checked = this.mode === 'all' || this.selected.includes(input.value); });
      requestAnimationFrame(() => this.updateArrows());
    }
    updateArrows() {
      if (!this.scroll || !this.root.isConnected) return;
      const maximum = this.scroll.scrollWidth - this.scroll.clientWidth;
      const previous = this.root.querySelector('[data-ewc-scroll="-1"]');
      const next = this.root.querySelector('[data-ewc-scroll="1"]');
      if (previous) previous.disabled = this.scroll.scrollLeft <= 2;
      if (next) next.disabled = this.scroll.scrollLeft >= maximum - 2;
    }
    setupDrag() {
      if (!this.scroll) return;
      let drag = null;
      this.listen(this.scroll, 'pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a, button, input, select, label')) return;
        drag = { id: event.pointerId, x: event.clientX, left: this.scroll.scrollLeft, active: false };
      });
      this.listen(this.scroll, 'pointermove', (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.active && Math.abs(distance) > 5) {
          drag.active = true; this.scroll.setPointerCapture(event.pointerId); this.scroll.classList.add('is-dragging');
        }
        if (drag.active) { event.preventDefault(); this.scroll.scrollLeft = drag.left - distance; }
      });
      const stop = () => { drag = null; this.scroll.classList.remove('is-dragging'); };
      this.listen(this.scroll, 'pointerup', stop);
      this.listen(this.scroll, 'pointercancel', stop);
      this.listen(this.scroll, 'lostpointercapture', stop);
      this.listen(this.scroll, 'pointerleave', () => { if (!drag?.active) stop(); });
    }
    selectEditorBlock(id) {
      const attribute = this.attributes.find((item) => String(item.id) === String(id));
      if (attribute) {
        this.expanded = true; this.renderComparison();
        const row = [...this.root.querySelectorAll('[data-ewc-attribute]')].find((item) => item.dataset.ewcAttribute === String(id));
        row?.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    }
    destroy() { this.abort.abort(); roots.delete(this.root); instances.delete(this.root); }
  }
  const catalogRoots = (scope) => [...(scope.matches?.('[data-ewc-catalog]') ? [scope] : []), ...scope.querySelectorAll('[data-ewc-catalog]')];
  const init = (scope = document) => catalogRoots(scope).forEach((root) => {
    if (!instances.has(root)) { const instance = new Catalog(root); instances.set(root, instance); roots.add(root); }
  });
  window.EWCCollections = {
    init,
    filter: (group) => { let matched = false; roots.forEach((root) => { matched = instances.get(root)?.filter(group) || matched; }); return matched; }
  };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => catalogRoots(event.target).forEach((root) => instances.get(root)?.destroy()));
  document.addEventListener('ewc:filter', (event) => window.EWCCollections.filter(event.detail?.group || ''));
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ewc-filter-target], .ewc-guide [data-ewc-filter]');
    if (trigger) window.EWCCollections.filter(trigger.dataset.ewcFilterTarget ?? trigger.dataset.ewcFilter);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
